<template>
  <div class="addition-service-container">
    <div class="addition-service-title text1">附加服务</div>
    <el-form ref="additionServiceForm" class="addition-service-form" :model="ruleForm" :rules="rules">
      <el-form-item class="item-box-customs flex" label="报关服务" prop="customsService">
        <el-radio
          v-for="(item,index) in fbaExtend"
          v-model="ruleForm.customsService"
          :class="{'customsRadio-active': ruleForm.customsService == item.enCode}"
          :label="item.enCode"
        >{{ item.fullName }}</el-radio>
      </el-form-item>
      <el-form-item class="item-box-insurance flex" label="保险服务">
        <el-col :span="12">
          <el-switch v-model="ruleForm.buyInsurance" :active-value="1" :inactive-value="0" />
          <span v-if="ruleForm.buyInsurance == 1" class="insurance-tips">购买保险，请填写投保信息</span>
        </el-col>
        <el-col v-if="ruleForm.buyInsurance == 1" :span="12" class="flex">
          <el-form-item class="item-box-beneficiary flex" label="受益人类型">
            <el-radio v-model="ruleForm.insuranceInfo.benefitType" :label="1">企业</el-radio>
            <el-radio v-model="ruleForm.insuranceInfo.benefitType" :label="2">个人</el-radio>
          </el-form-item>
        </el-col>
      </el-form-item>
      <div v-if="ruleForm.buyInsurance == 1" class="beneficiary-enterprise">
        <el-form-item
          v-if="ruleForm.insuranceInfo.benefitType == 1"
          label="受益企业"
          class="flex"
          prop="insuranceName"
        >
          <el-input
            v-model="ruleForm.insuranceInfo.insuranceName"
            style="width: 420px;"
            placeholder="投保受益企业（公司全称）"
          />
        </el-form-item>
        <el-form-item
          v-else-if="ruleForm.insuranceInfo.benefitType == 2"
          label="受益个人"
          class="flex"
          prop="individual"
        >
          <el-col :span="9">
            <el-input
              v-model="ruleForm.insuranceInfo.beneficiary"
              style="width: 300px;"
              placeholder="投保受益人姓名（实名）"
            />
          </el-col>
          <el-col :span="9" class="margin-left_30">
            <el-input v-model="ruleForm.insuranceInfo.idCard" style="width: 300px;" placeholder="身份证号码" />
          </el-col>
        </el-form-item>
        <el-form-item label="投保信息" class="flex" prop="articles">
          <el-col :span="7">
            <el-input
              v-model="ruleForm.insuranceInfo.nameCh"
              style="width: 200px;"
              placeholder="投保物品（中文名）"
            />
          </el-col>
          <el-col :span="7">
            <el-input
              v-model="ruleForm.insuranceInfo.nameEn"
              style="width: 200px;"
              placeholder="投保物品（英文名）"
            />
          </el-col>
          <el-col :span="7">
            <el-input v-model="ruleForm.insuranceInfo.buyAmount" style="width: 320px;" placeholder="物品声明价值">
              <template slot="append">
                <el-select v-model="ruleForm.currencyType">
                  <el-option
                    v-for="(item,index) in currencyTypeList"
                    :key="item.enCode"
                    :label="item.fullName"
                    :value="item.enCode"
                  />
                </el-select>
              </template>
            </el-input>
          </el-col>
        </el-form-item>
      </div>
      <el-form-item class="item-box-file flex" label="发货文件" prop="deliveryFile">
        <el-upload
          :on-change="handleChange"
          :file-list="fileList"
          :before-upload="handleBeforeUpload"
          :on-remove="fileHandleOnRemove"
          :on-success="(response, file, fileList) => fileHandleSuccess(response, file, fileList)"
          :action="define.comUrl + '/api/file/Uploader/TemporaryFile'"
        >
          <el-button size="mini" class="upload-btn">
            <img src="@/assets/img/client/booking/delivery-upload.png" width="16" height="11">
            <span>点击上传</span>
          </el-button>
        </el-upload>
      </el-form-item>
      <el-form-item class="item-box-remark flex" label="下单备注" prop="remark">
        <el-input
          v-model="ruleForm.remark"
          type="textarea"
          :rows="3"
          style="width: 875px;"
          resize="none"
          placeholder="如您有其他要求，可在此填写"
        />
      </el-form-item>
      <div class="next-step">
        <button class="next-step-btn" @click.prevent="onSubmit">完成</button>
      </div>
    </el-form>

  </div>
</template>
<script>
import request from '@/utils/request'
import define from '@/utils/define'
import {
  getCookie
} from '@/utils/cookiejs'

export default {
  name: 'Index',
  components: {

  },
  data() {
    return {
      data: {},
      ruleForm: {
        customsService: '',
        insuranceInfo: {
          benefitType: 1,
          insuranceName: '',
          beneficiary: '',
          idCard: '',
          nameCh: '',
          nameEn: '',
          buyAmount: 0
        },
        remark: '',
        buyInsurance: 0,
        attachList: [],
        currencyType: 'USD'
      },
      rules: {
        customsService: [{
          required: true,
          message: '请选择报关方式',
          trigger: 'blur'
        }],
        insuranceName: [{
          required: true,
          validator: this.validateInsuranceName,
          trigger: ['blur', 'change']
        }],
        individual: [{
          required: true,
          validator: this.validateIndividual,
          trigger: ['blur', 'change']
        }],
        articles: [{
          required: true,
          validator: this.validateArticles,
          trigger: ['blur', 'change']
        }]
      },
      fileList: [],
      currencyTypeList: [],
      fbaExtend: []

    }
  },
  created() {
    this.getCurrencyType()
    this.getFbaExtend()
  },
  methods: {
    init(data) {
      this.data = data
      console.log(this.data)
      if (this.data.customsService) {
        this.ruleForm.customsService = this.data.customsService
      }
      if (this.data.insuranceInfo) {
        this.ruleForm.insuranceInfo = this.data.insuranceInfo
      }
      if (this.data.remark) {
        this.ruleForm.remark = this.data.remark
      }
      if (this.data.buyInsurance) {
        this.ruleForm.buyInsurance = this.data.buyInsurance
      }
      if (this.data.attachList) {
        this.ruleForm.attachList = this.data.attachList
      }
    },
    validateInsuranceName(rule, value, callback) {
      const {
        insuranceName
      } = this.ruleForm.insuranceInfo
      if (!insuranceName) {
        callback(new Error('请选择输入受益企业'))
      } else {
        callback()
      }
    },
    validateArticles(rule, value, callback) {
      const {
        nameCh,
        nameEn,
        buyAmount
      } = this.ruleForm.insuranceInfo
      if (!nameCh || !nameEn || !buyAmount) {
        callback(new Error('请输入投保信息'))
      } else {
        callback()
      }
    },
    validateIndividual(rule, value, callback) {
      const {
        beneficiary,
        idCard
      } = this.ruleForm.insuranceInfo
      if (!beneficiary || !idCard) {
        callback(new Error('请输入受益人信息'))
      } else {
        callback()
      }
    },
    handleBeforeUpload() {

    },
    fileHandleOnRemove() {

    },
    fileHandleSuccess(response, file, fileList) {
      this.fileList = fileList

      this.ruleForm.attachList.push({
        fileId: file.response.data.url.split('/').pop(),
        name: file.name,
        size: file.size,
        url: file.response.data.url
      })
    },
    handleChange() {

    },
    onSubmit() {
      this.$nextTick(() => {
        this.$refs['additionServiceForm'].validate((valid) => {
          if (valid) {

          }
        })
      })
    },
    getCurrencyType() {
      request({
        url: '/api/system/DictionaryData/CurrencyType/Data/Selector',
        method: 'get',
        headers: {
          Authorization: getCookie('token')
        }
      }).then(res => {
        this.currencyTypeList = res.data.list
      })
    },
    getFbaExtend() {
      request({
        url: '/api/system/DictionaryData/CustomsService/Data/Selector',
        method: 'get',
        headers: {
          Authorization: getCookie('token')
        }
      }).then(res => {
        this.fbaExtend = res.data.list
      })
    },
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.additionServiceForm.validate((valid) => {
          if (valid) {
            // 验证通过，触发自定义事件并传递表单数据
            this.$emit('submitForm', this.ruleForm) // 将表单数据作为参数传递
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.addition-service-container {
		width: 100%;
		background-color: #fff;
		border-radius: 8px;
		box-sizing: border-box;
		text-align: left;
		padding: 20px;

		.addition-service-title {
			margin-bottom: 15px;
		}

		.addition-service-form {
			.item-box-customs {
				width: 100%;
				align-items: center;

				::v-deep .el-radio {
					border: 1px solid #E8E8E8;
					border-radius: 4px;
					padding: 10px 25px;
				}

				.customsRadio-active {
					border: 1px solid #3370FF;
				}
			}

			.item-box-insurance {
				::v-deep .el-form-item {
					margin: 0;
				}

				::v-deep .el-form-item__label {
					width: 78px;
					text-align: right;
				}

				::v-deep .el-form-item__content {
					width: 60%;
				}

				::v-deep .el-switch {
					margin-bottom: 4px;
				}

				.insurance-tips {
					margin-left: 10px;
					font-weight: 500;
				}
			}

			.item-box-beneficiary {
				::v-deep .el-form-item__label {
					width: 120px;
					text-align: left;
				}

				::v-deep .el-form-item__content {
					width: 100%;
				}
			}

			.beneficiary-enterprise {
				box-sizing: border-box;
				margin-left: 75px;
				border-radius: 8px;
				background: #F7F8FA;
				padding: 20px 20px 2px 20px;
				margin-bottom: 20px;

				::v-deep .el-form-item__content {
					width: 90%;
				}

				::v-deep .el-input-group__append {
					width: 100px;
					padding: 0 20px;
				}

			}

			.item-box-file {

				::v-deep .el-form-item__label {
					width: 78px;
					text-align: right;
				}

				.upload-btn {
					background: #F6F9FF;
					border: 1px solid #D3E0FF;
					color: #3370FF;
				}
			}

			.item-box-remark {
				width: 100%;

				box-sizing: border-box;

				::v-deep .el-form-item__label {
					width: 78px;
					text-align: right;
				}
			}

			.next-step {
				width: 100%;
				text-align: right;

				.next-step-btn {
					width: 140px;
					height: 50px;
					font-size: 18px;
					background-color: #007BFF;
					color: white;
					border: none;
					border-radius: 3px;
					cursor: pointer;
				}
			}
		}

		.text1 {
			font-size: 14px;
			font-weight: bold;
			color: #333333;
		}

		.text2 {
			font-size: 14px;
			font-weight: 400;
			color: #777777;
		}

		.text3 {
			font-size: 14px;
			font-weight: 400;
			color: #333333;
		}
	}
</style>
